export const testingTheme = {
   light: {
      background: 'bg-primary-600',
      text: 'text-base-white'
   },
   dark: {}
}
